import type { ReactNode } from 'react'
import React, { createContext, useContext, useMemo } from 'react'

import type { Section } from '@fourthwall/services/dist/ShopRendererDraftApiClient'

import { useUnifiedPageLayoutQuery } from '../hooks/useUnifiedPageLayoutQuery'

type Props = { children: ReactNode }

export type PageLayoutContextType = {
  pageLayoutQuery: ReturnType<typeof useUnifiedPageLayoutQuery>['pageLayoutQuery']
  getSectionBySectionKey: (sectionId: string) => Section | undefined
}

export const PageLayoutContext = createContext<PageLayoutContextType | undefined>(undefined)

export const PageLayoutProvider = ({ children }: Props) => {
  const { pageLayoutQuery, getSectionBySectionKey } = useUnifiedPageLayoutQuery()

  const value = useMemo(
    () => ({
      pageLayoutQuery,
      getSectionBySectionKey,
    }),
    [pageLayoutQuery, getSectionBySectionKey],
  )

  return <PageLayoutContext.Provider value={value}>{children}</PageLayoutContext.Provider>
}

export const usePageLayoutContext = () => {
  const pageLayoutContext = useContext(PageLayoutContext)

  if (pageLayoutContext === undefined) {
    throw new Error('pageLayoutContext must be used within a PageLayoutProvider')
  }

  return pageLayoutContext
}
